import MarkerCycler from './MarkerCycler'

import './style.scss'

export { MarkerCycler }
export default MarkerCycler
